
import { defineComponent } from 'vue'
import Heading from '@/components/Heading.vue'

export default defineComponent(
{
    name: 'Help',
    components:
    {
        Heading
    }
})
